<script setup>
import Delimiter from '@sections/delimiter.vue'
import { useStoreStore } from '@stores/store'
import { computed } from 'vue'
import { useRoute } from 'vue-router'
import { useRouter } from 'vue-router'

import Button from '@components/global/button.vue'
import MerchCard from '@components/global/merch-card.vue'
import Select from '@components/global/select.vue'

const router = useRouter()
const route = useRoute()
const slug = computed(() => route.params.slug)

const store = useStoreStore()
const collection = computed(() => store.collection(route.params.slug) ?? null)
</script>
<template>
	<section class="container">
		<div class="flex items-center gap-4">
			<Button :simple="true" class="outlined icon" @click="router.back()">
				<i class="fa-regular fa-arrow-left h-4 w-4" />
			</Button>
			<router-link :to="{ name: 'merch' }" class="h9">merch</router-link>
			<i class="fa-solid fa-chevron-right text-[#C1C18D]" />
			<span class="h9">{{ collection.title }}</span>
		</div>
	</section>
	<section class="container flex flex-col gap-6">
		<div class="flex flex-col justify-between gap-4 md:flex-row">
			<h4 class="font-extrabold capitalize">{{ collection.title }}</h4>
			<!-- <Select placeholder="Order by: Recent added" class="input" /> -->
		</div>
		<div class="grid grid-cols-1 gap-6 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4">
			<MerchCard class="card" :item="item" v-for="item in collection.products" />
		</div>
		<!-- <Button class="outlined w-fit self-center" label="Load more products" /> -->
	</section>
	<Delimiter />
</template>

<style>
.btn.icon {
	@apply h-10 w-10;
}

.input {
	@apply w-[300px];
}

.card.btn {
	@apply p-0;
}
</style>
